"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6a6 6 0 100 12 6 6 0 000-12zm1.98 9H10.2V9h3.772v.9h-2.764v1.663h2.369v.857h-2.369v1.68h2.772v.9z" }), "Editions");
//# sourceMappingURL=Editions.js.map